import { BookManagement } from "apiEndPoints";
import { logger } from "utils";
import APIrequest from "../../axios";

// AdminManageBookServices contains functions to interact with book management-related APIs.
// Each function corresponds to a specific API endpoint for tasks such as fetching book, updating book status, etc.
export const AdminManageBookServices = {
  /**
   * Function for fetching book data based on query parameters.
   * @param {Object} queryParams - Query parameters for fetching book.
   * @returns {Promise<Object>} - A promise that resolves to the response from the get book API.
   */
  getBookService: async (queryParams) => {
    try {
      const payload = {
        ...BookManagement.getBookList,
        queryParams,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  /**
   * Function for adding a new book.
   * @param {Object} bodyData - New book information.
   * @returns {Promise<Object>} - A promise that resolves to the response from the add book API.
   */
  addBookData: async (bodyData) => {
    try {
      const payload = {
        ...BookManagement.addBook,
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  /**
   * Function for deleting a book.
   * @param {string} id - ID of the book to be deleted.
   * @returns {Promise<Object>} - A promise that resolves to the response from the delete book API.
   */
  deleteBookById: async (id) => {
    try {
      const payload = {
        ...BookManagement.deleteBookById(id),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  /**
   * Function for fetching a single book.
   * @param {string} id - ID of the book to be fetched.
   * @returns {Promise<Object>} - A promise that resolves to the response from the get single book API.
   */
  getSingleBookById: async (id) => {
    try {
      const payload = {
        ...BookManagement.getSingleBookById(id),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  /**
   * Function for updating a book.
   * @param {Object} bodyData - Updated book information.
   * @param {string} id - ID of the book to be updated.
   * @returns {Promise<Object>} - A promise that resolves to the response from the update book API.
   */
  updateBookService: async (bodyData, id) => {
    try {
      const payload = {
        ...BookManagement.updateBook(id),
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  /**
   * Function for updating a Book status.
   * @param {Object} bodyData - Updated Book status.
   * @param {string} id - ID of the Book to be updated.
   * @returns {Promise<Object>} - A promise that resolves to the response from the update Book status API.
   */
  updateBookStatus: async (id, bodyData) => {
    try {
      const payload = {
        ...BookManagement.updateBookStatus(id),
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
    }
  },

  /**
   * Function for updating a book summary status.
   * @param {Object} status - Updated book status.
   * @param {string} id - ID of the book to be updated.
   * @returns {Promise<Object>} - A promise that resolves to the response from the update book summary Status API.
   */
  acceptRejectStatus: async (id, status) => {
    try {
      const payload = {
        ...BookManagement.updateBookAcceptRejectStatus(id, status),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  /**
   * Function for generating a book summary.
   * @param {string} id - ID of the book whose summary needs to be generated.
   * @returns {Promise<Object>} - A promise that resolves to the response from the generate summary API.
   */
  generateSummary: async (id) => {
    try {
      const payload = {
        ...BookManagement.generateSummary(id),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },


  /**
   * Function for fetching book requests.
   * @returns {Promise<Object>} - A promise that resolves to the response from the get book requests API.
   */
  getBookRequest: async (queryParams) => {
    try {
      const payload = {
        ...BookManagement.getBookRequest,
        queryParams,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
};
